//Configuracion columnas Tracking
export const columnsTracking = [
  { CAMPODES: "DO", NOMCOLXX: "MDOSYYYY.DOCNROXX", SHOWCOLX: "SI", CAMPKEYX: "SI", CENTERXX: true },
  //Bloqueo por discrepancia documentos vs parametrica (2026-07-23): la
  //operacion bloqueada no puede completar RCs hasta restablecer coherencia.
  { CAMPODES: "Bloqueada", NOMCOLXX: "BLOQUEDAX", SHOWCOLX: "SI", CAMPKEYX: "NO", SELECTXX: "NO", CENTERXX: true, WIDTHXXX: "110px", UNSORTED: true },
  //Estado de la operación (modelo 2026-08-12): columna FIJA como el DO —
  //el estado es la respuesta a "¿cómo va?" y no puede ser opcional verla.
  { CAMPODES: "Estado", NOMCOLXX: "MDOSYYYY.DOCESTUL", SHOWCOLX: "SI", CAMPKEYX: "SI", CENTERXX: true },
  //Ubicación de la carga (persistida por el mismo comando de estados):
  //EN ORIGEN, ETA-N, terminal/depósito, ENTREGADO...
  { CAMPODES: "Ubicación", NOMCOLXX: "MDOSYYYY.DOCUBICX", SHOWCOLX: "SI", CAMPKEYX: "NO", CENTERXX: true },
  { CAMPODES: "Pedido", NOMCOLXX: "MDOSYYYY.DOIPEDXX", SHOWCOLX: "SI", CAMPKEYX: "SI", CENTERXX: true },
  {
    CAMPODES: "Cliente",
    NOMCOLXX: "CIPO0024.CLINOMCX",
    SHOWCOLX: "SI",
    CAMPKEYX: "SI",
    CENTERXX: true,
  },
  {
    CAMPODES: "Línea de Negocio",
    NOMCOLXX: "CIPO0119.LINEDESX",
    SHOWCOLX: "NO",
    CAMPKEYX: "NO",
    SELECTXX: "NO",
    CENTERXX: true,
  },
  {
    CAMPODES: "Sucursal",
    NOMCOLXX: "MDOSYYYY.SUCIDXXX",
    SHOWCOLX: "NO",
    CAMPKEYX: "NO",
    SELECTXX: "NO",
    CENTERXX: true,
  },
  {
    CAMPODES: "Medio de transporte",
    NOMCOLXX: "CIPO0013.MTRDESXX",
    SHOWCOLX: "NO",
    CAMPKEYX: "NO",
    SELECTXX: "NO",
    CENTERXX: true,
  },
  {
    CAMPODES: "Documento de transporte",
    NOMCOLXX: "MDOSYYYY.DOCTRIMP",
    SHOWCOLX: "SI",
    CAMPKEYX: "SI",
    CENTERXX: true,
  },
  {
    CAMPODES: "Documento Soporte Valor",
    NOMCOLXX: "MDFAYYYY.FACIDXXX",
    SHOWCOLX: "NO",
    CAMPKEYX: "SI",
    CENTERXX: true,
  },
  {
    CAMPODES: "Coordinador de cuenta",
    NOMCOLXX: "CUENTNOM",
    SHOWCOLX: "NO",
    CAMPKEYX: "NO",
    SELECTXX: "NO",
    CENTERXX: true,
  },
  {
    CAMPODES: "Coordinador de operaciones",
    NOMCOLXX: "OPERANOM",
    SHOWCOLX: "NO",
    CAMPKEYX: "NO",
    SELECTXX: "NO",
    CENTERXX: true,
  },
  {
    CAMPODES: "Tipo de declaración",
    NOMCOLXX: "MDOSYYYY.DOCTIPDE",
    SHOWCOLX: "NO",
    CAMPKEYX: "NO",
    SELECTXX: "NO",
    CENTERXX: true,
  },
  {
    CAMPODES: "Estado de facturación",
    NOMCOLXX: "CIPF0051.ESTAFADE",
    SHOWCOLX: "NO",
    CAMPKEYX: "NO",
    SELECTXX: "NO",
    CENTERXX: true,
  },
  {
    CAMPODES: "Usuario Modificación ",
    NOMCOLXX: "USRNOMMD",
    SHOWCOLX: "SI",
    CAMPKEYX: "SI",
    SELECTXX: "NO",
    CENTERXX: true,
  },
  {
    CAMPODES: "Fecha modificacion",
    NOMCOLXX: "MDOSYYYY.REGFECMX",
    SHOWCOLX: "SI",
    CAMPKEYX: "SI",
    SELECTXX: "NO",
    CENTERXX: true,
  },
  {
    CAMPODES: "Hora Modificación",
    NOMCOLXX: "MDOSYYYY.REGHORMX",
    SHOWCOLX: "SI",
    CAMPKEYX: "SI",
    SELECTXX: "NO",
    CENTERXX: true,
  },
  { CAMPODES: "Estado", NOMCOLXX: "MDOSYYYY.REGESTXX", SHOWCOLX: "NO", CAMPKEYX: "NO", CENTERXX: true },
  {
    CAMPODES: "Cantidad Controladores",
    NOMCOLXX: "COTRLLER",
    SHOWCOLX: "NO",
    CAMPKEYX: "NO",
    SELECTXX: "NO",
    CENTERXX: true,
    ISLINKXX: true,
  },
  {
    CAMPODES: "Estado DAS",
    NOMCOLXX: "MDDIESDA",
    SHOWCOLX: "NO",
    CAMPKEYX: "NO",
    SELECTXX: "NO",
    CENTERXX: true,
  },
  {
    CAMPODES: "Estado Descarga Reporte Documental",
    NOMCOLXX: "MDOSBNFG",
    SHOWCOLX: "NO",
    CAMPKEYX: "NO",
    SELECTXX: "NO",
    CENTERXX: true,
  },
  {
    CAMPODES: "Mensaje del DAS",
    NOMCOLXX: "MDDIMEDA",
    SHOWCOLX: "NO",
    CAMPKEYX: "NO",
    SELECTXX: "NO",
    CENTERXX: true,
  },
  {
    CAMPODES: "Estado TXT",
    NOMCOLXX: "MDIMYYYY.ENVDAVTE",
    SHOWCOLX: "NO",
    CAMPKEYX: "NO",
    SELECTXX: "NO",
    CENTERXX: true,
  },
  {
    CAMPODES: "EDI",
    NOMCOLXX: "MDIMYYYY.MDIMBLED",
    SHOWCOLX: "SI",
    CAMPKEYX: "NO",
    SELECTXX: "NO",
    CENTERXX: true,
  },
  { CAMPODES: "Criticidad de la Operación", NOMCOLXX: "MDSSYYYY.COLORXXX", SHOWCOLX: "NO", CAMPKEYX: "NO", CENTERXX: true, SELECTXX: "SI" },
  {
    CAMPODES: "Estado SLI",
    NOMCOLXX: "SODIYYYY.SODIREGS",
    SHOWCOLX: "NO",
    CAMPKEYX: "NO",
    SELECTXX: "NO",
    CENTERXX: true,
  },
  {
    CAMPODES: "Mensaje SLI",
    NOMCOLXX: "SODIYYYY.RESPONSE",
    SHOWCOLX: "NO",
    CAMPKEYX: "NO",
    SELECTXX: "NO",
    CENTERXX: true,
  },
];

//Configuracion para la columnas que manejsa color en sus valores
export const settingsColorStatus = [
  {
    title: "BLOQUEDAX",
    params: [
      { value: "SI", color: "error-500" },
      { value: "NO", color: "success-400" },
    ],
  },
  {
    //Color por etapa del modelo de estados: planeación ámbar, desvíos
    //azul informativo, nacionalización azul primario (inspección en rojo:
    //exige atención), finalización verde.
    title: "DOCESTUL",
    params: [
      { value: "EN PLANEACION", color: "warning-600" },
      { value: "EN ENTREGA URGENTE", color: "info-600" },
      { value: "EN FINALIZACION DE ENTREGA URGENTE", color: "info-600" },
      { value: "EN TRANSITO ADUANERO", color: "info-600" },
      { value: "EN DIP", color: "info-600" },
      { value: "EN ACEPTACION", color: "primary-600" },
      { value: "EN PAGO", color: "primary-600" },
      { value: "EN NACIONALIZACION", color: "primary-600" },
      { value: "EN INSPECCION FISICA O DOCUMENTAL", color: "error-500" },
      { value: "EN PROCESO DE ENTREGA AL TRANSPORTADOR", color: "success-400" },
      { value: "EN FACTURACION", color: "success-400" },
      { value: "EN ENTREGA A ARCHIVO", color: "success-400" },
    ],
  },
  {
    title: "ESTGEDES",
    params: [
      { value: "Alta", color: "secondary-500" },
      { value: "Media", color: "primary-600" },
      { value: "Baja", color: "success-400" },
    ],
  },
];

export const columnsConsult = [
  // ── Campos heredados (no incluidos en la especificación pero en uso) ──────────
  {
    CAMPODES: "Usuario Creación",
    NOMCOLXX: "MDOSYYYY.REGUSRXX",
    TIPCAMXX: "SELECCION",
    FUNCTION: "getUserById",
    OPTIONSX: [],
  },
  {
    CAMPODES: "Estado",
    NOMCOLXX: "MDOSYYYY.REGESTXX",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "ACTIVO", label: "ACTIVO" },
      { value: "INACTIVO", label: "INACTIVO" },
      { value: "FACTURADO", label: "FACTURADO" },
    ],
  },
  {
    CAMPODES: "Estado Descarga Reporte Documental",
    NOMCOLXX: "MDOSBNFG",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "FINALIZADO", label: "FINALIZADO" },
      { value: "PENDIENTE", label: "PENDIENTE" },
    ],
  },
  { CAMPODES: "Fecha de Creación", NOMCOLXX: "MDOSYYYY.REGFECXX", TIPCAMXX: "FECHA", FUNCTION: "" },
  { CAMPODES: "Fecha de Modificación", NOMCOLXX: "MDOSYYYY.REGFECMX", TIPCAMXX: "FECHA", FUNCTION: "" },
  {
    CAMPODES: "Resultado Clave",
    NOMCOLXX: "MDOBYYYY.RESCLAXX",
    TIPCAMXX: "SELECCION",
    FUNCTION: "getKeyResultsById",
    OPTIONSX: [],
  },
  {
    CAMPODES: "Controladores Asociados",
    NOMCOLXX: "MDCOYYYY.USRIDXXX",
    TIPCAMXX: "SELECCION",
    FUNCTION: "getUserById",
    OPTIONSX: [],
  },
  {
    CAMPODES: "Criticidad de la Operación",
    NOMCOLXX: "MDSSYYYY.COLORXXX",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "ROJO", label: "ROJO" },
      { value: "VERDE", label: "VERDE" },
      { value: "NARANJA", label: "NARANJA" },
    ],
  },

  // ── MDOS2026 ─────────────────────────────────────────────────────────────────
  {
    CAMPODES: "Numero del DO",
    NOMCOLXX: "MDOSYYYY.DOCNROXX",
    TIPCAMXX: "SELECCION",
    FUNCTION: "getDoByNumber",
    OPTIONSX: [],
  },
  {
    CAMPODES: "Sucursal",
    NOMCOLXX: "MDOSYYYY.SUCIDXXX",
    TIPCAMXX: "SELECCION",
    FUNCTION: "getSucursalById",
    OPTIONSX: [],
  },
  {
    CAMPODES: "Documento de Transporte",
    NOMCOLXX: "MDOSYYYY.DOCTRIMP",
    TIPCAMXX: "SELECCION",
    FUNCTION: "getDocTransByFilter",
    OPTIONSX: [],
  },
  {
    CAMPODES: "Cliente",
    NOMCOLXX: "MDOSYYYY.CLIIDXXX",
    TIPCAMXX: "SELECCION",
    FUNCTION: "getClientById",
    OPTIONSX: [],
  },
  {
    CAMPODES: "Proveedor",
    NOMCOLXX: "MDOSYYYY.IDPROXXX",
    TIPCAMXX: "SELECCION",
    FUNCTION: "getProviderById",
    OPTIONSX: [],
  },
  {
    CAMPODES: "Tipo de Operación",
    NOMCOLXX: "MDOSYYYY.DOCTIPXX",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "IMPORTACION", label: "Importacion" },
    ],
  },
  { CAMPODES: "Pedido", NOMCOLXX: "MDOSYYYY.DOIPEDXX", TIPCAMXX: "ALFANUMERICO", FUNCTION: "", OPTIONSX: [] },
  {
    CAMPODES: "Temporal",
    NOMCOLXX: "MDOSYYYY.DOTEMPXX",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "SI", label: "SI" },
      { value: "NO", label: "NO" },
    ],
  },
  {
    CAMPODES: "Transportador Internacional",
    NOMCOLXX: "MDOSYYYY.TRANIDXX",
    TIPCAMXX: "SELECCION",
    FUNCTION: "getTransportById",
    OPTIONSX: [],
  },
  { CAMPODES: "Fecha de Emision Doc. Transporte", NOMCOLXX: "MDOSYYYY.FECEMIDT", TIPCAMXX: "FECHA", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Hora de Emision Doc. Transporte", NOMCOLXX: "MDOSYYYY.HOREMIDT", TIPCAMXX: "HORA", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Fecha de Liberacion Doc. Transporte", NOMCOLXX: "MDOSYYYY.FECLIBDT", TIPCAMXX: "FECHA", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Hora de Liberacion Doc. Transporte", NOMCOLXX: "MDOSYYYY.HORLIBDT", TIPCAMXX: "HORA", FUNCTION: "", OPTIONSX: [] },
  {
    CAMPODES: "¿Aplica Liberacion Doc. Transporte?",
    NOMCOLXX: "MDOSYYYY.APLLIBXX",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "SI", label: "SI" },
      { value: "NO", label: "NO" },
    ],
  },
  {
    CAMPODES: "Numero de Manifiesto",
    NOMCOLXX: "MDOSYYYY.DOCNUMAX",
    TIPCAMXX: "SELECCION",
    FUNCTION: "getManifestById",
    OPTIONSX: [],
  },
  { CAMPODES: "Peso Bruto Doc. Transporte", NOMCOLXX: "MDOSYYYY.PESDOCTR", TIPCAMXX: "NUMERICO", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Bultos Doc. Transporte", NOMCOLXX: "MDOSYYYY.BULDOCTR", TIPCAMXX: "NUMERICO", FUNCTION: "", OPTIONSX: [] },
  {
    CAMPODES: "Pais de Origen",
    NOMCOLXX: "MDOSYYYY.PAIIDORX",
    TIPCAMXX: "SELECCION",
    FUNCTION: "getPaisById",
    OPTIONSX: [],
  },
  {
    CAMPODES: "Tipo de Seguro",
    NOMCOLXX: "MDOSYYYY.MDOSTISE",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "CERTIFICACION DEL SEGURO", label: "CERTIFICACION DEL SEGURO" },
      { value: "COTIZACIÓN DEL SEGURO", label: "COTIZACIÓN DEL SEGURO" },
    ],
  },
  {
    CAMPODES: "¿Aplica DIP?",
    NOMCOLXX: "MDOSYYYY.REQINSPR",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "SI", label: "SI" },
      { value: "NO", label: "NO" },
    ],
  },
  {
    CAMPODES: "¿Aplica Verificacion de Mercancia?",
    NOMCOLXX: "MDOSYYYY.DOCMERRE",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "SI", label: "SI" },
      { value: "NO", label: "NO" },
    ],
  },
  { CAMPODES: "Fecha de Inspeccion", NOMCOLXX: "MDOSYYYY.FECHINSP", TIPCAMXX: "FECHA", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Hora de Inspeccion", NOMCOLXX: "MDOSYYYY.HORHINSP", TIPCAMXX: "HORA", FUNCTION: "", OPTIONSX: [] },
  {
    CAMPODES: "¿Aplica Toma de Muestras?",
    NOMCOLXX: "MDOSYYYY.APLTOMTR",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "SI", label: "SI" },
      { value: "NO", label: "NO" },
    ],
  },
  {
    CAMPODES: "Tipo de Declaracion",
    NOMCOLXX: "MDOSYYYY.DOCTIPDE",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "ANTICIPADA", label: "ANTICIPADA" },
      { value: "CORRECCIÓN", label: "CORRECCIÓN" },
      { value: "INICIAL", label: "INICIAL" },
      { value: "LEGALIZACIÓN", label: "LEGALIZACIÓN" },
      { value: "LIBRE", label: "LIBRE" },
      { value: "MODIFICACIÓN", label: "MODIFICACIÓN" },
      { value: "PREVIA", label: "PREVIA" },
    ],
  },
  {
    CAMPODES: "Tipo de Registro",
    NOMCOLXX: "MDOSYYYY.DOCTIPRE",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "GLOBAL", label: "GLOBAL" },
      { value: "ESPECIFICO", label: "ESPECIFICO" },
    ],
  },
  {
    CAMPODES: "Jurisdiccion Aduanera",
    NOMCOLXX: "MDOSYYYY.DOCJURAD",
    TIPCAMXX: "SELECCION",
    FUNCTION: "getJurisdictionById",
    OPTIONSX: [],
  },
  {
    CAMPODES: "Medio de Transporte",
    NOMCOLXX: "MDOSYYYY.MTRIDXXX",
    TIPCAMXX: "SELECCION",
    FUNCTION: "getMedTransportById",
    OPTIONSX: [],
  },
  {
    CAMPODES: "¿Rembolsable?",
    NOMCOLXX: "MDOSYYYY.MDOSREMB",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "SI", label: "SI" },
      { value: "NO", label: "NO" },
    ],
  },
  { CAMPODES: "Fecha Levante", NOMCOLXX: "MDOSYYYY.DOCFELEV", TIPCAMXX: "FECHA", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Hora Levante", NOMCOLXX: "MDOSYYYY.DOCHOLEV", TIPCAMXX: "HORA", FUNCTION: "", OPTIONSX: [] },
  {
    CAMPODES: "Pais de Compra",
    NOMCOLXX: "MDOSYYYY.PAIIDXXX",
    TIPCAMXX: "SELECCION",
    FUNCTION: "getPaisById",
    OPTIONSX: [],
  },
  {
    CAMPODES: "Sucursal (Linea)",
    NOMCOLXX: "MDOSYYYY.MDOSLING",
    TIPCAMXX: "SELECCION",
    FUNCTION: "getBranchById",
    OPTIONSX: [],
  },
  {
    CAMPODES: "Modo de Transporte",
    NOMCOLXX: "MDOSYYYY.DOCMTXXX",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "MARITIMO", label: "MARITIMO" },
      { value: "AEREO", label: "AEREO" },
      { value: "TRANSITO", label: "TRANSITO" },
      { value: "TERRESTRE", label: "TERRESTRE" },
      { value: "NO APLICA", label: "NO APLICA" },
    ],
  },
  { CAMPODES: "Fecha de Manifiesto", NOMCOLXX: "MDOSYYYY.DOCFEMAX", TIPCAMXX: "FECHA", FUNCTION: "", OPTIONSX: [] },
  {
    CAMPODES: "KPI de la Operación",
    NOMCOLXX: "MDOSYYYY.TOKIDXXX",
    TIPCAMXX: "SELECCION",
    FUNCTION: "getKpiById",
    OPTIONSX: [],
  },
  { CAMPODES: "Fecha y Hora Factura/Proforma", NOMCOLXX: "MDOSYYYY.COMHFPRO", TIPCAMXX: "FECHAHORA", FUNCTION: "", OPTIONSX: [] },
  {
    CAMPODES: "Proforma",
    NOMCOLXX: "MDOSYYYY.COMFAPRO",
    TIPCAMXX: "SELECCION",
    FUNCTION: "getProformaById",
    OPTIONSX: [],
  },
  {
    CAMPODES: "¿Aplica Proyecto?",
    NOMCOLXX: "MDOSYYYY.APLPROXX",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "SI", label: "SI" },
      { value: "NO", label: "NO" },
    ],
  },
  {
    CAMPODES: "Aduana de Destino",
    NOMCOLXX: "MDOSYYYY.DOCJURAO",
    TIPCAMXX: "SELECCION",
    FUNCTION: "getJurisdictionById",
    OPTIONSX: [],
  },
  {
    //Ubicación de la carga: texto libre porque el dominio incluye nombres
    //de depósitos (CONTECAR...) que crecen con la parametría.
    CAMPODES: "Ubicacion de la Carga",
    NOMCOLXX: "MDOSYYYY.DOCUBICX",
    TIPCAMXX: "",
    FUNCTION: "",
    OPTIONSX: [],
  },
  {
    //Estados del modelo de importación (docs/estados-de-la-operacion.pdf).
    //Lista fija: el estado es derivado y su dominio es cerrado; la función
    //getEstadoOperById que había aquí no existía en ningún lado.
    CAMPODES: "Estado de la Operacion",
    NOMCOLXX: "MDOSYYYY.DOCESTUL",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "EN PLANEACION", label: "EN PLANEACION" },
      { value: "EN ENTREGA URGENTE", label: "EN ENTREGA URGENTE" },
      { value: "EN FINALIZACION DE ENTREGA URGENTE", label: "EN FINALIZACION DE ENTREGA URGENTE" },
      { value: "EN TRANSITO ADUANERO", label: "EN TRANSITO ADUANERO" },
      { value: "EN DIP", label: "EN DIP" },
      { value: "EN ACEPTACION", label: "EN ACEPTACION" },
      { value: "EN PAGO", label: "EN PAGO" },
      { value: "EN INSPECCION FISICA O DOCUMENTAL", label: "EN INSPECCION FISICA O DOCUMENTAL" },
      { value: "EN NACIONALIZACION", label: "EN NACIONALIZACION" },
      { value: "EN PROCESO DE ENTREGA AL TRANSPORTADOR", label: "EN PROCESO DE ENTREGA AL TRANSPORTADOR" },
      { value: "EN FACTURACION", label: "EN FACTURACION" },
      { value: "EN ENTREGA A ARCHIVO", label: "EN ENTREGA A ARCHIVO" },
    ],
  },
  {
    CAMPODES: "¿Aplica Entrega Urgente?",
    NOMCOLXX: "MDOSYYYY.DOCDDOEU",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "SI", label: "SI" },
      { value: "NO", label: "NO" },
    ],
  },

  // ── MDDI2026 ─────────────────────────────────────────────────────────────────
  { CAMPODES: "Secuencia de la Declaracion", NOMCOLXX: "MDDIYYYY.SUBIDXXX", TIPCAMXX: "ALFANUMERICO", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Declarante Autorizado", NOMCOLXX: "MDDIYYYY.USRNOMXX", TIPCAMXX: "ALFANUMERICO", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Direccion del Cliente", NOMCOLXX: "MDDIYYYY.CLIDIRXX", TIPCAMXX: "ALFANUMERICO", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Numero del Cliente", NOMCOLXX: "MDDIYYYY.CLITELXX", TIPCAMXX: "ALFANUMERICO", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Departamento del Proveedor", NOMCOLXX: "MDDIYYYY.CLIDEPID", TIPCAMXX: "ALFANUMERICO", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Ciudad del Cliente", NOMCOLXX: "MDDIYYYY.CLICIUID", TIPCAMXX: "ALFANUMERICO", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Fax del Proveedor", NOMCOLXX: "MDDIYYYY.PIEFAXXX", TIPCAMXX: "ALFANUMERICO", FUNCTION: "", OPTIONSX: [] },
  {
    CAMPODES: "Forma de Pago",
    NOMCOLXX: "MDDIYYYY.FPIIDXXX",
    TIPCAMXX: "SELECCION",
    FUNCTION: "getFormsPayById",
    OPTIONSX: [],
  },

  // ── MDFA2026 ─────────────────────────────────────────────────────────────────
  {
    CAMPODES: "Factura Comercial",
    NOMCOLXX: "MDFAYYYY.FACIDXXX",
    TIPCAMXX: "SELECCION",
    FUNCTION: "getInvoiceByFilter",
    OPTIONSX: [],
  },
  { CAMPODES: "Tipo Importador", NOMCOLXX: "MDFAYYYY.TIMIDXXX", TIPCAMXX: "ALFANUMERICO", FUNCTION: "", OPTIONSX: [] },
  {
    CAMPODES: "Moneda",
    NOMCOLXX: "MDFAYYYY.MONIDXXX",
    TIPCAMXX: "SELECCION",
    FUNCTION: "getMonedaById",
    OPTIONSX: [],
  },
  { CAMPODES: "Fecha de la Factura", NOMCOLXX: "MDFAYYYY.FACFECXX", TIPCAMXX: "FECHA", FUNCTION: "", OPTIONSX: [] },
  {
    CAMPODES: "Termino de la Negociacion",
    NOMCOLXX: "MDFAYYYY.TERMIDXX",
    TIPCAMXX: "SELECCION",
    FUNCTION: "getTermNegById",
    OPTIONSX: [],
  },
  { CAMPODES: "Valor de la Factura", NOMCOLXX: "MDFAYYYY.VALFACXX", TIPCAMXX: "NUMERICO", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Valor Deducciones Factura", NOMCOLXX: "MDFAYYYY.VALDEDUC", TIPCAMXX: "NUMERICO", FUNCTION: "", OPTIONSX: [] },
  {
    CAMPODES: "¿Factura Completa para Items?",
    NOMCOLXX: "MDFAYYYY.MDFABANC",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "COMPLETA", label: "COMPLETA" },
      { value: "INCOMPLETA", label: "INCOMPLETA" },
    ],
  },
  {
    CAMPODES: "¿Factura Completa para Valoracion?",
    NOMCOLXX: "MDFAYYYY.MDFABCOV",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "COMPLETA", label: "COMPLETA" },
      { value: "INCOMPLETA", label: "INCOMPLETA" },
    ],
  },
  { CAMPODES: "Numero de Orden de Factura", NOMCOLXX: "MDFAYYYY.MDFAFAOR", TIPCAMXX: "ALFANUMERICO", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Lugar de Entrega", NOMCOLXX: "MDFAYYYY.MDFALUEN", TIPCAMXX: "ALFANUMERICO", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Tipo de Cambio Fijo", NOMCOLXX: "MDFAYYYY.MDFACAMO", TIPCAMXX: "NUMERICO", FUNCTION: "", OPTIONSX: [] },
  {
    CAMPODES: "Tradicion Documental Factura",
    NOMCOLXX: "MDFAYYYY.TRADOCXX",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "ORIGINAL", label: "ORIGINAL" },
      { value: "COPIA", label: "COPIA" },
    ],
  },
  {
    CAMPODES: "Descriptor",
    NOMCOLXX: "MDFAYYYY.DESIDXXX",
    TIPCAMXX: "SELECCION",
    FUNCTION: "getDescriptorById",
    OPTIONSX: [],
  },

  // ── MDDT2026 ─────────────────────────────────────────────────────────────────
  { CAMPODES: "Flete Doc. Transporte", NOMCOLXX: "MDDTYYYY.VALFLEXX", TIPCAMXX: "NUMERICO", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Seguro Doc. Transporte", NOMCOLXX: "MDDTYYYY.VALSEGXX", TIPCAMXX: "NUMERICO", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Valor Otros Gastos Doc. Transporte", NOMCOLXX: "MDDTYYYY.VALOTRXX", TIPCAMXX: "NUMERICO", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Deducciones Doc. Transporte", NOMCOLXX: "MDDTYYYY.VALDEDUC", TIPCAMXX: "NUMERICO", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "FOB Doc. Transporte", NOMCOLXX: "MDDTYYYY.VALFOBGA", TIPCAMXX: "NUMERICO", FUNCTION: "", OPTIONSX: [] },
  {
    CAMPODES: "¿Aplica Endoso?",
    NOMCOLXX: "MDDTYYYY.MDDTBAEN",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "SI", label: "SI" },
      { value: "NO", label: "NO" },
    ],
  },
  {
    CAMPODES: "Tradicion Documental Doc. Transporte",
    NOMCOLXX: "MDDTYYYY.TRADOCXX",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "ORIGINAL", label: "ORIGINAL" },
      { value: "COPIA", label: "COPIA" },
    ],
  },

  // ── MDFG2026 ─────────────────────────────────────────────────────────────────
  { CAMPODES: "Concepto Adicional Factura", NOMCOLXX: "MDFGYYYY.MDFGCONC", TIPCAMXX: "ALFANUMERICO", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Valor Concepto Adicional", NOMCOLXX: "MDFGYYYY.MDFGVALX", TIPCAMXX: "NUMERICO", FUNCTION: "", OPTIONSX: [] },
  {
    CAMPODES: "Categoria del Concepto Adicional",
    NOMCOLXX: "MDFGYYYY.MDFGASIG",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "FOB", label: "FOB" },
      { value: "FLETE", label: "FLETE" },
      { value: "SEGURO", label: "SEGURO" },
      { value: "OTROS GASTOS", label: "OTROS GASTOS" },
      { value: "DEDUCCIONES", label: "DEDUCCIONES" },
    ],
  },

  // ── MDFI2026 ─────────────────────────────────────────────────────────────────
  { CAMPODES: "Lote", NOMCOLXX: "MDFIYYYY.ITELOTXX", TIPCAMXX: "ALFANUMERICO", FUNCTION: "", OPTIONSX: [] },

  // ── MDIA2026 ─────────────────────────────────────────────────────────────────
  { CAMPODES: "Acta de Entrega", NOMCOLXX: "MDIAYYYY.AEMIDXXX", TIPCAMXX: "ALFANUMERICO", FUNCTION: "", OPTIONSX: [] },
  {
    CAMPODES: "Transportador Local",
    NOMCOLXX: "MDIAYYYY.TRALIDXX",
    TIPCAMXX: "SELECCION",
    FUNCTION: "getCarrierLocalById",
    OPTIONSX: [],
  },
  { CAMPODES: "Valor CIF", NOMCOLXX: "MDIAYYYY.AEMCIFXX", TIPCAMXX: "NUMERICO", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Nombre del Conductor", NOMCOLXX: "MDIAYYYY.AEMCONDX", TIPCAMXX: "ALFANUMERICO", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Identificacion del Conductor", NOMCOLXX: "MDIAYYYY.AEMCEDUX", TIPCAMXX: "ALFANUMERICO", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Placa del Vehiculo de Entrega", NOMCOLXX: "MDIAYYYY.AEMPLACX", TIPCAMXX: "ALFANUMERICO", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Fecha Entrega Acta al Transportador", NOMCOLXX: "MDIAYYYY.FECENTXX", TIPCAMXX: "FECHA", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Hora Entrega Acta al Transportador", NOMCOLXX: "MDIAYYYY.HORENTXX", TIPCAMXX: "HORA", FUNCTION: "", OPTIONSX: [] },

  // ── MDID2026 ─────────────────────────────────────────────────────────────────
  { CAMPODES: "Cantidad Diferente en Productos", NOMCOLXX: "MDIDYYYY.MDIDCANT", TIPCAMXX: "NUMERICO", FUNCTION: "", OPTIONSX: [] },

  // ── MDIF2026 ─────────────────────────────────────────────────────────────────
  { CAMPODES: "Cantidad Faltante en Productos", NOMCOLXX: "MDIFYYYY.MDIFCANT", TIPCAMXX: "NUMERICO", FUNCTION: "", OPTIONSX: [] },

  // ── MDIM2026 ─────────────────────────────────────────────────────────────────
  {
    CAMPODES: "Tipo de Normalizacion",
    NOMCOLXX: "MDIMYYYY.MDIMTIAN",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "LEGAL", label: "LEGAL" },
      { value: "VOLUNTARIA", label: "VOLUNTARIA" },
    ],
  },
  { CAMPODES: "Inicio de DIP", NOMCOLXX: "MDIMYYYY.MDFHINDI", TIPCAMXX: "FECHAHORA", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Fin de DIP", NOMCOLXX: "MDIMYYYY.MDFHFMDI", TIPCAMXX: "FECHAHORA", FUNCTION: "", OPTIONSX: [] },
  {
    CAMPODES: "Retiro de Muestras",
    NOMCOLXX: "MDIMYYYY.MDIMREMU",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "SI", label: "SI" },
      { value: "NO", label: "NO" },
    ],
  },
  {
    CAMPODES: "¿Verificado?",
    NOMCOLXX: "MDIMYYYY.MDIMVERR",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "SI", label: "SI" },
      { value: "NO", label: "NO" },
    ],
  },
  {
    CAMPODES: "Tipo de Nacionalizacion",
    NOMCOLXX: "MDIMYYYY.MDIMBNAP",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "PARCIAL", label: "PARCIAL" },
      { value: "COMPLETA", label: "COMPLETA" },
    ],
  },
  {
    CAMPODES: "Tipo de Mercancia",
    NOMCOLXX: "MDIMYYYY.TIPIDXXX",
    TIPCAMXX: "SELECCION",
    FUNCTION: "getTipMercanciaById",
    OPTIONSX: [],
  },
  {
    CAMPODES: "Tipo de Embalaje",
    NOMCOLXX: "MDIMYYYY.TEMIDXXX",
    TIPCAMXX: "SELECCION",
    FUNCTION: "getEmbalajeById",
    OPTIONSX: [],
  },
  {
    CAMPODES: "Enviado Via Portal",
    NOMCOLXX: "MDIMYYYY.ENVSOCPL",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "SI", label: "SI" },
      { value: "NO", label: "NO" },
    ],
  },
  {
    CAMPODES: "Aceptacion Integracion Texmoda",
    NOMCOLXX: "MDIMYYYY.ENVACETE",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "ENVIADO", label: "ENVIADO" },
    ],
  },
  {
    CAMPODES: "Levante Integracion Texmoda",
    NOMCOLXX: "MDIMYYYY.ENVLEVTE",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "ENVIADO", label: "ENVIADO" },
    ],
  },
  {
    CAMPODES: "DAV Integracion Texmoda",
    NOMCOLXX: "MDIMYYYY.ENVDAVTE",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "ENVIADO", label: "ENVIADO" },
    ],
  },
  { CAMPODES: "IMEIS Apple", NOMCOLXX: "MDIMYYYY.MDDINUIM", TIPCAMXX: "ALFANUMERICO", FUNCTION: "", OPTIONSX: [] },
  {
    CAMPODES: "Estado del DAS",
    NOMCOLXX: "MDIMYYYY.MDDIESDA",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "ERROR", label: "ERROR" },
      { value: "ENVIADA", label: "ENVIADA" },
      { value: "GENERADA", label: "GENERADA" },
    ],
  },
  { CAMPODES: "Mensaje DAS", NOMCOLXX: "MDIMYYYY.MDDIMEDA", TIPCAMXX: "ALFANUMERICO", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Fecha de Mandato", NOMCOLXX: "MDIMYYYY.MDDIFEMA", TIPCAMXX: "FECHA", FUNCTION: "", OPTIONSX: [] },
  {
    CAMPODES: "Entrega Total",
    NOMCOLXX: "MDIMYYYY.MDIMBENT",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "SI", label: "SI" },
      { value: "NO", label: "NO" },
    ],
  },
  { CAMPODES: "Poliza de Operacion", NOMCOLXX: "MDIMYYYY.MDIMVALS", TIPCAMXX: "NUMERICO", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "PO Bavaria", NOMCOLXX: "MDIMYYYY.MDIMBAPO", TIPCAMXX: "ALFANUMERICO", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "MIGO Bavaria", NOMCOLXX: "MDIMYYYY.MDIMBAMI", TIPCAMXX: "ALFANUMERICO", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Posicion Bavaria", NOMCOLXX: "MDIMYYYY.MDIMBAPS", TIPCAMXX: "ALFANUMERICO", FUNCTION: "", OPTIONSX: [] },
  {
    CAMPODES: "¿Aplica Toma de Seriales HP?",
    NOMCOLXX: "MDIMYYYY.MDIMAPLS",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "SI", label: "SI" },
      { value: "NO", label: "NO" },
    ],
  },
  { CAMPODES: "Fecha de Seriales HP", NOMCOLXX: "MDIMYYYY.MDIMFESE", TIPCAMXX: "FECHA", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Hora de Seriales HP", NOMCOLXX: "MDIMYYYY.MDIMHOSE", TIPCAMXX: "HORA", FUNCTION: "", OPTIONSX: [] },
  {
    CAMPODES: "¿Contiene Instrucciones HP?",
    NOMCOLXX: "MDIMYYYY.MDIMBAIN",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "SI", label: "SI" },
      { value: "NO", label: "NO" },
    ],
  },
  { CAMPODES: "Fecha de Instruccion HP", NOMCOLXX: "MDIMYYYY.MDIMFEIN", TIPCAMXX: "FECHA", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Hora de Instruccion HP", NOMCOLXX: "MDIMYYYY.MDIMHOIN", TIPCAMXX: "HORA", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Fecha Llegada Zonafranca HP", NOMCOLXX: "MDIMYYYY.MDIMFEZO", TIPCAMXX: "FECHA", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Hora Llegada Zonafranca HP", NOMCOLXX: "MDIMYYYY.MDIMHOZO", TIPCAMXX: "HORA", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Fecha Formulario FFM Entrada HP", NOMCOLXX: "MDIMYYYY.MDIMFEFE", TIPCAMXX: "FECHA", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Fecha Formulario FFM Salida HP", NOMCOLXX: "MDIMYYYY.MDIMFEFS", TIPCAMXX: "FECHA", FUNCTION: "", OPTIONSX: [] },
  {
    CAMPODES: "¿Aplica Legalizacion Productos Inicial?",
    NOMCOLXX: "MDIMYYYY.MDIMALPR",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "SI", label: "SI" },
      { value: "NO", label: "NO" },
    ],
  },
  {
    CAMPODES: "¿Aplica Generacion de EDI?",
    NOMCOLXX: "MDIMYYYY.MDIMBLED",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "SI", label: "SI" },
      { value: "NO", label: "NO" },
    ],
  },
  {
    CAMPODES: "Apple Inventory",
    NOMCOLXX: "MDIMYYYY.MDIMINVE",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "INVENTORY", label: "INVENTORY" },
      { value: "NON INVENTORY", label: "NON INVENTORY" },
    ],
  },
  {
    CAMPODES: "¿Aplica Tender?",
    NOMCOLXX: "MDIMYYYY.MDIMTEND",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "SI", label: "SI" },
      { value: "NO", label: "NO" },
    ],
  },
  { CAMPODES: "Numero de DTA", NOMCOLXX: "MDIMYYYY.MDIMNRDT", TIPCAMXX: "ALFANUMERICO", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Fecha de Presentacion DTA", NOMCOLXX: "MDIMYYYY.MDIMNRDF", TIPCAMXX: "FECHA", FUNCTION: "", OPTIONSX: [] },
  {
    CAMPODES: "¿Aplica Inspeccion Fisica DTA?",
    NOMCOLXX: "MDIMYYYY.MDIMAPLF",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "SI", label: "SI" },
      { value: "NO", label: "NO" },
    ],
  },
  {
    CAMPODES: "¿Aplica DTA?",
    NOMCOLXX: "MDIMYYYY.MDIMDTAA",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "SI", label: "SI" },
      { value: "NO", label: "NO" },
    ],
  },
  { CAMPODES: "Numero Autorizacion DTA", NOMCOLXX: "MDIMYYYY.MDIMDTAU", TIPCAMXX: "ALFANUMERICO", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Fecha Autorizacion DTA", NOMCOLXX: "MDIMYYYY.MDIMDTAF", TIPCAMXX: "FECHA", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Fecha Salida Ultima Unidad Carga DTA", NOMCOLXX: "MDIMYYYY.MDIMFSUF", TIPCAMXX: "FECHA", FUNCTION: "", OPTIONSX: [] },
  {
    CAMPODES: "¿Cuenta con Autorizacion?",
    NOMCOLXX: "MDIMYYYY.AUDIGENX",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "SI", label: "SI" },
      { value: "NO", label: "NO" },
    ],
  },
  {
    CAMPODES: "¿Desistio DTA?",
    NOMCOLXX: "MDIMYYYY.MDIMDDTA",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "SI", label: "SI" },
      { value: "NO", label: "NO" },
    ],
  },
  {
    CAMPODES: "¿Cuenta con Autorizacion de Retiro?",
    NOMCOLXX: "MDIMYYYY.MDIMAURT",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "SI", label: "SI" },
      { value: "NO", label: "NO" },
    ],
  },
  {
    CAMPODES: "¿Genero Levante?",
    NOMCOLXX: "MDIMYYYY.MDIMBLLE",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "SI", label: "SI" },
      { value: "NO", label: "NO" },
    ],
  },

  // ── MDMD2026 ─────────────────────────────────────────────────────────────────
  {
    CAMPODES: "¿Aplica Medida Comercial?",
    NOMCOLXX: "MDMDYYYY.MDMDAPMD",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "SI", label: "SI" },
      { value: "NO", label: "NO" },
    ],
  },
  {
    CAMPODES: "Medida Comercial",
    NOMCOLXX: "MDMDYYYY.MEDCOIDX",
    TIPCAMXX: "SELECCION",
    FUNCTION: "getMedidaComercialById",
    OPTIONSX: [],
  },

  // ── MDOI2026 ─────────────────────────────────────────────────────────────────
  {
    CAMPODES: "Estado Indicador",
    NOMCOLXX: "MDOIYYYY.CUMPLEXX",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "ERROR_DATOS", label: "ERROR_DATOS" },
      { value: "SI", label: "SI" },
      { value: "NO", label: "NO" },
      { value: "POR VENCER", label: "POR VENCER" },
      { value: "VENCIDO", label: "VENCIDO" },
    ],
  },

  // ── MDPD2026 ─────────────────────────────────────────────────────────────────
  { CAMPODES: "Numero de ROP", NOMCOLXX: "MDPDYYYY.MDPDROPX", TIPCAMXX: "ALFANUMERICO", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Valor DIM", NOMCOLXX: "MDPDYYYY.MDPDVLRX", TIPCAMXX: "NUMERICO", FUNCTION: "", OPTIONSX: [] },
  {
    CAMPODES: "Estado Tarea Pago DIM",
    NOMCOLXX: "MDPDYYYY.ESTADOTA",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "GENERADA", label: "GENERADA" },
      { value: "PENDIENTE", label: "PENDIENTE" },
      { value: "ERROR", label: "ERROR" },
    ],
  },
  {
    CAMPODES: "Tipo de Pago DIM",
    NOMCOLXX: "MDPDYYYY.TIPOPAGO",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "PSE", label: "PSE" },
      { value: "CARTA BANCARIA", label: "CARTA BANCARIA" },
    ],
  },

  // ── MDPF2026 ─────────────────────────────────────────────────────────────────
  {
    CAMPODES: "Tipo de Facturacion",
    NOMCOLXX: "MDPFYYYY.TIPOFACX",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "CONSOLIDADA", label: "CONSOLIDADA" },
      { value: "POR OPERACION", label: "POR OPERACION" },
    ],
  },
  {
    CAMPODES: "Tipo de Factura",
    NOMCOLXX: "MDPFYYYY.FACTIPOX",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "PROPIOS Y TERCEROS", label: "PROPIOS Y TERCEROS" },
      { value: "PROPIOS", label: "PROPIOS" },
      { value: "TERCEROS", label: "TERCEROS" },
    ],
  },
  {
    CAMPODES: "Estado Factura Reintegros",
    NOMCOLXX: "MDPFYYYY.ESTAREFU",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "ERROR", label: "ERROR" },
      { value: "GENERADA", label: "GENERADA" },
      { value: "EN PROCESO", label: "EN PROCESO" },
    ],
  },
  { CAMPODES: "Fecha y Hora de la factura de reintegro", NOMCOLXX: "MDPFYYYY.REFUFHXX", TIPCAMXX: "FECHAHORA", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Tasa de Cambio", NOMCOLXX: "MDPFYYYY.TRMTASXX", TIPCAMXX: "NUMERICO", FUNCTION: "", OPTIONSX: [] },

  // ── MDPU2026 ─────────────────────────────────────────────────────────────────
  {
    CAMPODES: "Puerto de Embarque",
    NOMCOLXX: "MDPUYYYY.PUERIDXX",
    TIPCAMXX: "SELECCION",
    FUNCTION: "getPortById",
    OPTIONSX: [],
  },

  // ── MDPV2026 ─────────────────────────────────────────────────────────────────
  { CAMPODES: "Valor INVIMA", NOMCOLXX: "MDPVYYYY.MDPVVLRX", TIPCAMXX: "NUMERICO", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Codigo Tarifa INVIMA", NOMCOLXX: "MDPVYYYY.MDPVTARD", TIPCAMXX: "ALFANUMERICO", FUNCTION: "", OPTIONSX: [] },
  {
    CAMPODES: "Estado Tarea Pago INVIMA",
    NOMCOLXX: "MDPVYYYY.ESTADOTA",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "GENERADA", label: "GENERADA" },
      { value: "PENDIENTE", label: "PENDIENTE" },
      { value: "ERROR", label: "ERROR" },
    ],
  },

  // ── MDSC2026 ─────────────────────────────────────────────────────────────────
  { CAMPODES: "Numero de Contenedor Doc. Transporte", NOMCOLXX: "MDSCYYYY.MDSCNUCO", TIPCAMXX: "ALFANUMERICO", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Fecha Salida Ultima Unidad de Carga", NOMCOLXX: "MDSCYYYY.MDSCFECX", TIPCAMXX: "FECHA", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Hora Salida Ultima Unidad de Carga", NOMCOLXX: "MDSCYYYY.MDSCHORX", TIPCAMXX: "HORA", FUNCTION: "", OPTIONSX: [] },

  // ── MDSN2026 ─────────────────────────────────────────────────────────────────
  { CAMPODES: "Codigo Tarifa SNRI", NOMCOLXX: "MDSNYYYY.CODTARXX", TIPCAMXX: "ALFANUMERICO", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Cantidad de Facturas SNRI", NOMCOLXX: "MDSNYYYY.NUMTARXX", TIPCAMXX: "ALFANUMERICO", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Valor SNRI", NOMCOLXX: "MDSNYYYY.VALORXXX", TIPCAMXX: "NUMERICO", FUNCTION: "", OPTIONSX: [] },
  {
    CAMPODES: "Estado Tarea Pago SNRI",
    NOMCOLXX: "MDSNYYYY.ESTADOTA",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "GENERADA", label: "GENERADA" },
      { value: "PENDIENTE", label: "PENDIENTE" },
      { value: "ERROR", label: "ERROR" },
    ],
  },

  // ── MDSP2026 ─────────────────────────────────────────────────────────────────
  { CAMPODES: "Codigo Pago SISPAP", NOMCOLXX: "MDSPYYYY.MDSPIDXX", TIPCAMXX: "ALFANUMERICO", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Tipo de Pago SISPAP", NOMCOLXX: "MDSPYYYY.MDSPTIPO", TIPCAMXX: "ALFANUMERICO", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Valor SISPAP", NOMCOLXX: "MDSPYYYY.MDSPVLRX", TIPCAMXX: "NUMERICO", FUNCTION: "", OPTIONSX: [] },
  {
    CAMPODES: "Estado Tarea Pago SISPAP",
    NOMCOLXX: "MDSPYYYY.ESTADOTA",
    TIPCAMXX: "SELECCION",
    FUNCTION: "",
    OPTIONSX: [
      { value: "", label: "SELECCIONE" },
      { value: "GENERADA", label: "GENERADA" },
      { value: "PENDIENTE", label: "PENDIENTE" },
      { value: "ERROR", label: "ERROR" },
    ],
  },

  // ── MDDA2026 ─────────────────────────────────────────────────────────────────
  { CAMPODES: "Año de la DAV", NOMCOLXX: "MDDAYYYY.MDDAANIO", TIPCAMXX: "NUMERICO", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Numero de Formulario DAV", NOMCOLXX: "MDDAYYYY.MDDANUMF", TIPCAMXX: "ALFANUMERICO", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Digito de Verificacion DAV", NOMCOLXX: "MDDAYYYY.MDDADVER", TIPCAMXX: "ALFANUMERICO", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Numero de Aceptacion DAV", NOMCOLXX: "MDDAYYYY.LIMACEXX", TIPCAMXX: "ALFANUMERICO", FUNCTION: "", OPTIONSX: [] },
  { CAMPODES: "Fecha de Aceptacion DAV", NOMCOLXX: "MDDAYYYY.LIMFACEX", TIPCAMXX: "FECHA", FUNCTION: "", OPTIONSX: [] },
  {
    CAMPODES: "Nivel Comercial",
    NOMCOLXX: "MDDAYYYY.NIVELIDX",
    TIPCAMXX: "SELECCION",
    FUNCTION: "getNivelById",
    OPTIONSX: [],
  },
];

export const columnsExport = [
  { CAMPODES: "Numero del DO", NOMCOLXX: "MDOSYYYY.DOCNROXX" },
  { CAMPODES: "Sucursal", NOMCOLXX: "MDOSYYYY.SUCIDXXX" },
  { CAMPODES: "Documento de Transporte", NOMCOLXX: "MDOSYYYY.DOCTRIMP" },
  { CAMPODES: "Cliente", NOMCOLXX: "MDOSYYYY.CLIIDXXX" },
  { CAMPODES: "Proveedor", NOMCOLXX: "MDOSYYYY.IDPROXXX" },
  { CAMPODES: "Tipo de Operación", NOMCOLXX: "MDOSYYYY.DOCTIPXX" },
  { CAMPODES: "Pedido", NOMCOLXX: "MDOSYYYY.DOIPEDXX" },
  { CAMPODES: "Temporal", NOMCOLXX: "MDOSYYYY.DOTEMPXX" },
  { CAMPODES: "Transportador Internacional", NOMCOLXX: "MDOSYYYY.TRANIDXX" },
  { CAMPODES: "Fecha Emision Doc Transporte", NOMCOLXX: "MDOSYYYY.FECEMIDT" },
  { CAMPODES: "Hora Emision Doc Transporte", NOMCOLXX: "MDOSYYYY.HOREMIDT" },
  { CAMPODES: "Fecha Liberacion Doc Transporte", NOMCOLXX: "MDOSYYYY.FECLIBDT" },
  { CAMPODES: "Hora Liberacion Doc Transporte", NOMCOLXX: "MDOSYYYY.HORLIBDT" },
  { CAMPODES: "Aplica Liberacion Doc Transporte", NOMCOLXX: "MDOSYYYY.APLLIBXX" },
  { CAMPODES: "Numero de Manifiesto", NOMCOLXX: "MDOSYYYY.DOCNUMAX" },
  { CAMPODES: "Peso Bruto Doc Transporte", NOMCOLXX: "MDOSYYYY.PESDOCTR" },
  { CAMPODES: "Bultos Doc Transporte", NOMCOLXX: "MDOSYYYY.BULDOCTR" },
  { CAMPODES: "Pais de Origen", NOMCOLXX: "MDOSYYYY.PAIIDORX" },
  { CAMPODES: "Tipo de Seguro", NOMCOLXX: "MDOSYYYY.MDOSTISE" },
  { CAMPODES: "Aplica DIP", NOMCOLXX: "MDOSYYYY.REQINSPR" },
  { CAMPODES: "Aplica Verificacion de Mercancia", NOMCOLXX: "MDOSYYYY.DOCMERRE" },
  { CAMPODES: "Fecha de Inspeccion", NOMCOLXX: "MDOSYYYY.FECHINSP" },
  { CAMPODES: "Hora de Inspeccion", NOMCOLXX: "MDOSYYYY.HORHINSP" },
  { CAMPODES: "Aplica Toma de Muestras", NOMCOLXX: "MDOSYYYY.APLTOMTR" },
  { CAMPODES: "Tipo de Declaracion", NOMCOLXX: "MDOSYYYY.DOCTIPDE" },
  { CAMPODES: "Tipo de Registro", NOMCOLXX: "MDOSYYYY.DOCTIPRE" },
  { CAMPODES: "Jurisdiccion Aduanera", NOMCOLXX: "MDOSYYYY.DOCJURAD" },
  { CAMPODES: "Medio de Transporte", NOMCOLXX: "MDOSYYYY.MTRIDXXX" },
  { CAMPODES: "Rembolsable", NOMCOLXX: "MDOSYYYY.MDOSREMB" },
  { CAMPODES: "Fecha Levante", NOMCOLXX: "MDOSYYYY.DOCFELEV" },
  { CAMPODES: "Hora Levante", NOMCOLXX: "MDOSYYYY.DOCHOLEV" },
  { CAMPODES: "Pais de Compra", NOMCOLXX: "MDOSYYYY.PAIIDXXX" },
  { CAMPODES: "Sucursal Operacion", NOMCOLXX: "MDOSYYYY.MDOSLING" },
  { CAMPODES: "Modo de Transporte", NOMCOLXX: "MDOSYYYY.DOCMTXXX" },
  { CAMPODES: "Fecha de Manifiesto", NOMCOLXX: "MDOSYYYY.DOCFEMAX" },
  { CAMPODES: "KPI de la Operacion", NOMCOLXX: "MDOSYYYY.TOKIDXXX" },
  { CAMPODES: "Fecha y Hora Factura o Proforma", NOMCOLXX: "MDOSYYYY.COMHFPRO" },
  { CAMPODES: "Proforma", NOMCOLXX: "MDOSYYYY.COMFAPRO" },
  { CAMPODES: "Aplica Proyecto", NOMCOLXX: "MDOSYYYY.APLPROXX" },
  { CAMPODES: "Estado Descarga Reporte Documental", NOMCOLXX: "MDOSBNFG" },
  { CAMPODES: "Aduana de Destino", NOMCOLXX: "MDOSYYYY.DOCJURAO" },
  { CAMPODES: "Estado", NOMCOLXX: "MDOSYYYY.ESTAIDXX" },
  { CAMPODES: "Aplica Entrega Urgente", NOMCOLXX: "MDOSYYYY.DOCDDOEU" },
  { CAMPODES: "Secuencia de la Declaracion", NOMCOLXX: "MDDIYYYY.SUBIDXXX" },
  { CAMPODES: "Declarante Autorizado", NOMCOLXX: "MDDIYYYY.USRNOMXX" },
  { CAMPODES: "Direccion del Cliente", NOMCOLXX: "MDDIYYYY.CLIDIRXX" },
  { CAMPODES: "Telefono del Cliente", NOMCOLXX: "MDDIYYYY.CLITELXX" },
  { CAMPODES: "Departamento del Proveedor", NOMCOLXX: "MDDIYYYY.CLIDEPID" },
  { CAMPODES: "Ciudad del Cliente", NOMCOLXX: "MDDIYYYY.CLICIUID" },
  { CAMPODES: "Fax del Proveedor", NOMCOLXX: "MDDIYYYY.PIEFAXXX" },
  { CAMPODES: "Forma de Pago", NOMCOLXX: "MDDIYYYY.FPIIDXXX" },
  { CAMPODES: "Acta de Entrega", NOMCOLXX: "MDIAYYYY.AEMIDXXX" },
  { CAMPODES: "Transportador Local", NOMCOLXX: "MDIAYYYY.TRALIDXX" },
  { CAMPODES: "Valor CIF", NOMCOLXX: "MDIAYYYY.AEMCIFXX" },
  { CAMPODES: "Nombre del Conductor", NOMCOLXX: "MDIAYYYY.AEMCONDX" },
  { CAMPODES: "Identificacion del Conductor", NOMCOLXX: "MDIAYYYY.AEMCEDUX" },
  { CAMPODES: "Placa del Vehiculo de Entrega", NOMCOLXX: "MDIAYYYY.AEMPLACX" },
  { CAMPODES: "Fecha Entrega Acta Transportador", NOMCOLXX: "MDIAYYYY.FECENTXX" },
  { CAMPODES: "Hora Entrega Acta Transportador", NOMCOLXX: "MDIAYYYY.HORENTXX" },
  { CAMPODES: "Estado Indicador", NOMCOLXX: "MDOIYYYY.CUMPLEXX" },
  { CAMPODES: "Numero de ROP", NOMCOLXX: "MDPDYYYY.MDPDROPX" },
  { CAMPODES: "Valor DIM", NOMCOLXX: "MDPDYYYY.MDPDVLRX" },
  { CAMPODES: "Estado Tarea Pago DIM", NOMCOLXX: "MDPDYYYY.ESTADOTA_PD" },
  { CAMPODES: "Tipo de Pago DIM", NOMCOLXX: "MDPDYYYY.TIPOPAGO" },
  { CAMPODES: "Valor INVIMA", NOMCOLXX: "MDPVYYYY.MDPVVLRX" },
  { CAMPODES: "Codigo Tarifa INVIMA", NOMCOLXX: "MDPVYYYY.MDPVTARD" },
  { CAMPODES: "Estado Tarea Pago INVIMA", NOMCOLXX: "MDPVYYYY.ESTADOTA_PV" },
  { CAMPODES: "Codigo Tarifa SNRI", NOMCOLXX: "MDSNYYYY.CODTARXX" },
  { CAMPODES: "Cantidad Facturas SNRI", NOMCOLXX: "MDSNYYYY.NUMTARXX" },
  { CAMPODES: "Valor SNRI", NOMCOLXX: "MDSNYYYY.VALORXXX" },
  { CAMPODES: "Estado Tarea Pago SNRI", NOMCOLXX: "MDSNYYYY.ESTADOTA_SN" },
  { CAMPODES: "Codigo Pago SISPAP", NOMCOLXX: "MDSPYYYY.MDSPIDXX" },
  { CAMPODES: "Tipo de Pago SISPAP", NOMCOLXX: "MDSPYYYY.MDSPTIPO" },
  { CAMPODES: "Valor SISPAP", NOMCOLXX: "MDSPYYYY.MDSPVLRX" },
  { CAMPODES: "Estado Tarea Pago SISPAP", NOMCOLXX: "MDSPYYYY.ESTADOTA_SP" },
  { CAMPODES: "Puerto de Embarque", NOMCOLXX: "MDPUYYYY.PUERIDXX" },
  { CAMPODES: "Año de la DAV", NOMCOLXX: "MDDAYYYY.MDDAANIO" },
  { CAMPODES: "Numero de Formulario DAV", NOMCOLXX: "MDDAYYYY.MDDANUMF" },
  { CAMPODES: "Digito de Verificacion DAV", NOMCOLXX: "MDDAYYYY.MDDADVER" },
  { CAMPODES: "Numero de Aceptacion DAV", NOMCOLXX: "MDDAYYYY.LIMACEXX" },
  { CAMPODES: "Fecha de Aceptacion DAV", NOMCOLXX: "MDDAYYYY.LIMFACEX" },
  { CAMPODES: "Nivel Comercial", NOMCOLXX: "MDDAYYYY.NIVELIDX" },
  { CAMPODES: "Factura Comercial", NOMCOLXX: "MDFAYYYY.FACIDXXX" },
  { CAMPODES: "Tipo Importador", NOMCOLXX: "MDFAYYYY.TIMIDXXX" },
  { CAMPODES: "Moneda", NOMCOLXX: "MDFAYYYY.MONIDXXX" },
  { CAMPODES: "Fecha de la Factura", NOMCOLXX: "MDFAYYYY.FACFECXX" },
  { CAMPODES: "Termino de la Negociacion", NOMCOLXX: "MDFAYYYY.TERMIDXX" },
  { CAMPODES: "Valor de la Factura", NOMCOLXX: "MDFAYYYY.VALFACXX" },
  { CAMPODES: "Valor Deducciones Factura", NOMCOLXX: "MDFAYYYY.VALDEDUC" },
  { CAMPODES: "Factura Completa para Items del DO", NOMCOLXX: "MDFAYYYY.MDFABANC" },
  { CAMPODES: "Factura Completa para Valoracion", NOMCOLXX: "MDFAYYYY.MDFABCOV" },
  { CAMPODES: "Numero de Orden de Factura", NOMCOLXX: "MDFAYYYY.MDFAFAOR" },
  { CAMPODES: "Lugar de Entrega", NOMCOLXX: "MDFAYYYY.MDFALUEN" },
  { CAMPODES: "Tipo de Cambio Fijo", NOMCOLXX: "MDFAYYYY.MDFACAMO" },
  { CAMPODES: "Tradicion Documental Factura", NOMCOLXX: "MDFAYYYY.TRADOCXX" },
  // { CAMPODES: "Descriptor", NOMCOLXX: "MDFAYYYY.DESIDXXX" },
  { CAMPODES: "Concepto Adicional Factura", NOMCOLXX: "MDFGYYYY.MDFGCONC" },
  { CAMPODES: "Valor Concepto Adicional", NOMCOLXX: "MDFGYYYY.MDFGVALX" },
  { CAMPODES: "Categoria Concepto Adicional", NOMCOLXX: "MDFGYYYY.MDFGASIG" },
  { CAMPODES: "Tipo de Facturacion", NOMCOLXX: "MDPFYYYY.TIPOFACX" },
  { CAMPODES: "Tipo de Factura", NOMCOLXX: "MDPFYYYY.FACTIPOX" },
  { CAMPODES: "Estado Factura Reintegros", NOMCOLXX: "MDPFYYYY.ESTAREFU" },
  { CAMPODES: "Fecha y Hora Factura Reintegro", NOMCOLXX: "MDPFYYYY.REFUFHXX" },
  { CAMPODES: "Tasa de Cambio", NOMCOLXX: "MDPFYYYY.TRMTASXX" },
  { CAMPODES: "Flete Doc Transporte", NOMCOLXX: "MDDTYYYY.VALFLEXX" },
  { CAMPODES: "Seguro Doc Transporte", NOMCOLXX: "MDDTYYYY.VALSEGXX" },
  { CAMPODES: "Valor Otros Gastos Doc Transporte", NOMCOLXX: "MDDTYYYY.VALOTRXX" },
  { CAMPODES: "Deducciones Doc Transporte", NOMCOLXX: "MDDTYYYY.VALDEDUC" },
  { CAMPODES: "FOB Doc Transporte", NOMCOLXX: "MDDTYYYY.VALFOBGA" },
  { CAMPODES: "Aplica Endoso", NOMCOLXX: "MDDTYYYY.MDDTBAEN" },
  { CAMPODES: "Tradicion Documental Doc Transporte", NOMCOLXX: "MDDTYYYY.TRADOCXX" },
  { CAMPODES: "Numero de Contenedor", NOMCOLXX: "MDSCYYYY.MDSCNUCO" },
  { CAMPODES: "Fecha Salida Ultima Unidad de Carga", NOMCOLXX: "MDSCYYYY.MDSCFECX" },
  { CAMPODES: "Hora Salida Ultima Unidad de Carga", NOMCOLXX: "MDSCYYYY.MDSCHORX" },
  { CAMPODES: "Tipo de Embalaje", NOMCOLXX: "MDIMYYYY.TEMIDXXX" },
  { CAMPODES: "Tipo de Normalizacion", NOMCOLXX: "MDIMYYYY.MDIMTIAN" },
  { CAMPODES: "Inicio de DIP", NOMCOLXX: "MDIMYYYY.MDFHINDI" },
  { CAMPODES: "Fin de DIP", NOMCOLXX: "MDIMYYYY.MDFHFMDI" },
  { CAMPODES: "Retiro de Muestras", NOMCOLXX: "MDIMYYYY.MDIMREMU" },
  { CAMPODES: "Verificado", NOMCOLXX: "MDIMYYYY.MDIMVERR" },
  { CAMPODES: "Tipo de Nacionalizacion", NOMCOLXX: "MDIMYYYY.MDIMBNAP" },
  { CAMPODES: "Tipo de Mercancia", NOMCOLXX: "MDIMYYYY.TIPIDXXX" },
  { CAMPODES: "Enviado Via Portal", NOMCOLXX: "MDIMYYYY.ENVSOCPL" },
  { CAMPODES: "Aceptacion Integracion Texmoda", NOMCOLXX: "MDIMYYYY.ENVACETE" },
  { CAMPODES: "Levante Integracion Texmoda", NOMCOLXX: "MDIMYYYY.ENVLEVTE" },
  { CAMPODES: "DAV Integracion Texmoda", NOMCOLXX: "MDIMYYYY.ENVDAVTE" },
  { CAMPODES: "IMEIS Apple", NOMCOLXX: "MDIMYYYY.MDDINUIM" },
  { CAMPODES: "Estado del DAS", NOMCOLXX: "MDIMYYYY.MDDIESDA" },
  { CAMPODES: "Mensaje DAS", NOMCOLXX: "MDIMYYYY.MDDIMEDA" },
  { CAMPODES: "Estado TXT", NOMCOLXX: "MDIMYYYY.ENVDAVTE" },
  { CAMPODES: "Fecha de Mandato", NOMCOLXX: "MDIMYYYY.MDDIFEMA" },
  { CAMPODES: "Entrega Total", NOMCOLXX: "MDIMYYYY.MDIMBENT" },
  { CAMPODES: "Poliza de Operacion", NOMCOLXX: "MDIMYYYY.MDIMVALS" },
  { CAMPODES: "PO Bavaria", NOMCOLXX: "MDIMYYYY.MDIMBAPO" },
  { CAMPODES: "MIGO Bavaria", NOMCOLXX: "MDIMYYYY.MDIMBAMI" },
  { CAMPODES: "Posicion Bavaria", NOMCOLXX: "MDIMYYYY.MDIMBAPS" },
  { CAMPODES: "Aplica Toma de Seriales HP", NOMCOLXX: "MDIMYYYY.MDIMAPLS" },
  { CAMPODES: "Fecha Seriales HP", NOMCOLXX: "MDIMYYYY.MDIMFESE" },
  { CAMPODES: "Hora Seriales HP", NOMCOLXX: "MDIMYYYY.MDIMHOSE" },
  { CAMPODES: "Contiene Instrucciones Cliente HP", NOMCOLXX: "MDIMYYYY.MDIMBAIN" },
  { CAMPODES: "Fecha Instruccion Cliente HP", NOMCOLXX: "MDIMYYYY.MDIMFEIN" },
  { CAMPODES: "Hora Instruccion Cliente HP", NOMCOLXX: "MDIMYYYY.MDIMHOIN" },
  { CAMPODES: "Fecha Llegada Zonafranca HP", NOMCOLXX: "MDIMYYYY.MDIMFEZO" },
  { CAMPODES: "Hora Llegada Zonafranca HP", NOMCOLXX: "MDIMYYYY.MDIMHOZO" },
  { CAMPODES: "Fecha Formulario FFM Entrada HP", NOMCOLXX: "MDIMYYYY.MDIMFEFE" },
  { CAMPODES: "Fecha Formulario FFM Salida HP", NOMCOLXX: "MDIMYYYY.MDIMFEFS" },
  { CAMPODES: "Aplica Legalizacion Productos Inicial", NOMCOLXX: "MDIMYYYY.MDIMALPR" },
  { CAMPODES: "Aplica Generacion de EDI", NOMCOLXX: "MDIMYYYY.MDIMBLED" },
  { CAMPODES: "Apple Inventory", NOMCOLXX: "MDIMYYYY.MDIMINVE" },
  { CAMPODES: "Aplica Tender", NOMCOLXX: "MDIMYYYY.MDIMTEND" },
  { CAMPODES: "Numero de DTA", NOMCOLXX: "MDIMYYYY.MDIMNRDT" },
  { CAMPODES: "Fecha Presentacion DTA", NOMCOLXX: "MDIMYYYY.MDIMNRDF" },
  { CAMPODES: "Aplica Inspeccion Fisica DTA", NOMCOLXX: "MDIMYYYY.MDIMAPLF" },
  { CAMPODES: "Aplica DTA", NOMCOLXX: "MDIMYYYY.MDIMDTAA" },
  { CAMPODES: "Numero Autorizacion DTA", NOMCOLXX: "MDIMYYYY.MDIMDTAU" },
  { CAMPODES: "Fecha Autorizacion DTA", NOMCOLXX: "MDIMYYYY.MDIMDTAF" },
  { CAMPODES: "Fecha Salida Ultima Unidad DTA", NOMCOLXX: "MDIMYYYY.MDIMFSUF" },
  { CAMPODES: "Cuenta con Autorizacion", NOMCOLXX: "MDIMYYYY.AUDIGENX" },
  { CAMPODES: "Desistio DTA", NOMCOLXX: "MDIMYYYY.MDIMDDTA" },
  { CAMPODES: "Cuenta con Autorizacion de Retiro", NOMCOLXX: "MDIMYYYY.MDIMAURT" },
  { CAMPODES: "Genero Levante", NOMCOLXX: "MDIMYYYY.MDIMBLLE" },
  { CAMPODES: "Secuencia del Item", NOMCOLXX: "MDFIYYYY.SECITEXX" },
  { CAMPODES: "Saldo Reservado", NOMCOLXX: "MDFIYYYY.ITERESXX" },
  { CAMPODES: "Tipo de Producto", NOMCOLXX: "MDFIYYYY.TIPPROID" },
  { CAMPODES: "Tipo de Modalidad", NOMCOLXX: "MDFIYYYY.MODIDXXX" },
  { CAMPODES: "Acuerdo Comercial Item", NOMCOLXX: "MDFIYYYY.GRUCOIDX" },
  { CAMPODES: "Acuerdo Comercial Item DIAN", NOMCOLXX: "MDFIYYYY.ACUDIIDX" },
  { CAMPODES: "Lote del Item", NOMCOLXX: "MDFIYYYY.ITELOTXX" },
  { CAMPODES: "Valor del Item", NOMCOLXX: "MDFIYYYY.VALTOITE" },
  { CAMPODES: "Seguro del Item", NOMCOLXX: "MDFIYYYY.VALSEGIT" },
  { CAMPODES: "Valor Flete del Item", NOMCOLXX: "MDFIYYYY.VALFLEIT" },
  { CAMPODES: "Cantidad", NOMCOLXX: "MDFIYYYY.CANITEXX" },
  { CAMPODES: "Registro Completo", NOMCOLXX: "MDFIYYYY.MDFIRECO" },
  { CAMPODES: "Descriptor Completo", NOMCOLXX: "MDFIYYYY.MDFIDMCO" },
  { CAMPODES: "Completa la Modalidad", NOMCOLXX: "MDFIYYYY.MDFIMOCO" },
  { CAMPODES: "Datos Complementarios Completos", NOMCOLXX: "MDFIYYYY.MDFIDCCO" },
  { CAMPODES: "Autorizacion de Restriccion Legal", NOMCOLXX: "MDFIYYYY.AUTRELGC" },
  { CAMPODES: "Exclusion del Beneficio de Origen", NOMCOLXX: "MDFIYYYY.AUTEXBOR" },
  { CAMPODES: "Peso Bruto del Item", NOMCOLXX: "MDFIYYYY.MDFIPSBP" },
  { CAMPODES: "Peso Neto del Item", NOMCOLXX: "MDFIYYYY.MDFIPSNT" },
  { CAMPODES: "Estado de la Mercancia", NOMCOLXX: "MDFIYYYY.ESTMERID" },
  { CAMPODES: "Año de Fabricacion", NOMCOLXX: "MDFIYYYY.ANIOFABX" },
  { CAMPODES: "Unidad del Item", NOMCOLXX: "MDFIYYYY.UNIIDXXX" },
  { CAMPODES: "IVA del Item", NOMCOLXX: "MDFIYYYY.MDIFIVAX" },
  { CAMPODES: "Valor Arancel del Item", NOMCOLXX: "MDFIYYYY.MDFIARAN" },
  { CAMPODES: "Segundo Codigo de Producto", NOMCOLXX: "MDFIYYYY.MDFISECO" },
  { CAMPODES: "Cantidad Segun Subpartida", NOMCOLXX: "MDFIYYYY.MDFICANS" },
  // { CAMPODES: "Descriptor del Item", NOMCOLXX: "MDFLYYYY.DESIDXXX" },
  { CAMPODES: "Aplica Medida Comercial", NOMCOLXX: "MDMDYYYY.MDMDAPMD" },
  { CAMPODES: "Medida Comercial", NOMCOLXX: "MDMDYYYY.MEDCOIDX" },
  { CAMPODES: "Cantidad Diferente en Productos", NOMCOLXX: "MDIDYYYY.MDIDCANT" },
  { CAMPODES: "Cantidad Faltante en Productos", NOMCOLXX: "MDIFYYYY.MDIFCANT" },
  { CAMPODES: "Lote", NOMCOLXX: "MDFLYYYY.VALOTXXX" },
  { CAMPODES: "DO (DAV)", NOMCOLXX: "MDDAYYYY_DAV.DOCNROXX" },
  { CAMPODES: "Secuencia DAV", NOMCOLXX: "MDDAYYYY_DAV.MDDASECX" },
  { CAMPODES: "Año (Cas. 1)", NOMCOLXX: "MDDAYYYY_DAV.MDDAANIO" },
  { CAMPODES: "Numero de Formulario (Cas. 4)", NOMCOLXX: "MDDAYYYY_DAV.MDDANUMF" },
  { CAMPODES: "NIT Importador (Cas. 5)", NOMCOLXX: "MDDAYYYY_DAV.CLIIDXXX" },
  { CAMPODES: "DV (Cas. 6)", NOMCOLXX: "MDDAYYYY_DAV.MDDADVER" },
  { CAMPODES: "Primer Apellido (Cas. 7)", NOMCOLXX: "MDDAYYYY_DAV.CLIPRIAP" },
  { CAMPODES: "Segundo Apellido (Cas. 8)", NOMCOLXX: "MDDAYYYY_DAV.CLISEGAP" },
  { CAMPODES: "Primer Nombre (Cas. 9)", NOMCOLXX: "MDDAYYYY_DAV.CLIPRINO" },
  { CAMPODES: "Otros Nombres (Cas. 10)", NOMCOLXX: "MDDAYYYY_DAV.CLISEGNO" },
  { CAMPODES: "Razon Social (Cas. 11)", NOMCOLXX: "MDDAYYYY_DAV.CLINOMXX" },
  { CAMPODES: "Codigo Direccion Seccional (Cas. 24)", NOMCOLXX: "MDDAYYYY_DAV.ODIIDXXX" },
  { CAMPODES: "Numero Declaracion Importacion (Cas. 25)", NOMCOLXX: "MDDAYYYY_DAV.LIMACEXX" },
  { CAMPODES: "Fecha Declaracion (Cas. 26)", NOMCOLXX: "MDDAYYYY_DAV.LIMFACEX" },
  { CAMPODES: "Tipo Declaracion Importacion (Cas. 27)", NOMCOLXX: "MDDAYYYY_DAV.TDEIDXXX" },
  { CAMPODES: "Nivel Comercial Comprador (Cas. 28)", NOMCOLXX: "MDDAYYYY_DAV.NIVELIDX" },
  { CAMPODES: "Nivel Comercial Especifique (Cas. 29)", NOMCOLXX: "MDDAYYYY_DAV.NIVELDEX" },
  { CAMPODES: "Condicion Vendedor (Cas. 30)", NOMCOLXX: "MDDAYYYY_DAV.PROCONVE" },
  { CAMPODES: "Condicion Vendedor Especifique (Cas. 31)", NOMCOLXX: "MDDAYYYY_DAV.PROCONTX" },
  { CAMPODES: "Resolucion (Cas. 32)", NOMCOLXX: "MDDAYYYY_DAV.NUMRESXX" },
  { CAMPODES: "Fecha Resolucion (Cas. 33)", NOMCOLXX: "MDDAYYYY_DAV.FECRESXX" },
  { CAMPODES: "Tipo Resolucion (Cas. 34)", NOMCOLXX: "MDDAYYYY_DAV.TIPRESXX" },
  { CAMPODES: "Naturaleza Transaccion (Cas. 35)", NOMCOLXX: "MDDAYYYY_DAV.NATIDXXX" },
  { CAMPODES: "Forma de Envio (Cas. 36)", NOMCOLXX: "MDDAYYYY_DAV.CLIPROFE" },
  { CAMPODES: "Condiciones de Entrega (Cas. 37)", NOMCOLXX: "MDDAYYYY_DAV.TERMIDXX" },
  { CAMPODES: "Lugar Entrega (Cas. 38)", NOMCOLXX: "MDDAYYYY_DAV.LUGENTXX" },
  { CAMPODES: "Pais Procedencia (Cas. 39)", NOMCOLXX: "MDDAYYYY_DAV.PAIIDXXX" },
  { CAMPODES: "Factura (Cas. 40)", NOMCOLXX: "MDDAYYYY_DAV.FACIDXXX" },
  { CAMPODES: "Fecha Factura (Cas. 41)", NOMCOLXX: "MDDAYYYY_DAV.FACFECXX" },
  { CAMPODES: "Tipo Contrato (Cas. 42)", NOMCOLXX: "MDDAYYYY_DAV.CONTRAID" },
  { CAMPODES: "Numero Contrato (Cas. 43)", NOMCOLXX: "MDDAYYYY_DAV.CLIPRONC" },
  { CAMPODES: "Fecha Contrato (Cas. 44)", NOMCOLXX: "MDDAYYYY_DAV.CLIPROFC" },
  { CAMPODES: "Valor Contrato (Cas. 45)", NOMCOLXX: "MDDAYYYY_DAV.CLIPROVC" },
  { CAMPODES: "Valor FOB Total (Cas. 46)", NOMCOLXX: "MDDAYYYY_DAV.VALFOBXX" },
  { CAMPODES: "Moneda (Cas. 47)", NOMCOLXX: "MDDAYYYY_DAV.MONIDXXX" },
  { CAMPODES: "Tipo de Cambio (Cas. 48)", NOMCOLXX: "MDDAYYYY_DAV.TIPCAMXX" },
  { CAMPODES: "Fecha Tipo de Cambio (Cas. 49)", NOMCOLXX: "MDDAYYYY_DAV.TIPCAMFE" },
  { CAMPODES: "Moneda 2 (Cas. 50)", NOMCOLXX: "MDDAYYYY_DAV.MDDAMONX" },
  { CAMPODES: "Tipo Cambio 2 (Cas. 51)", NOMCOLXX: "MDDAYYYY_DAV.MDDATIPX" },
  { CAMPODES: "Fecha Tipo Cambio 2 (Cas. 52)", NOMCOLXX: "MDDAYYYY_DAV.MDDATIPF" },
  { CAMPODES: "Moneda 3 (Cas. 53)", NOMCOLXX: "MDDAYYYY_DAV.MDDAMONT" },
  { CAMPODES: "Tipo Cambio 3 (Cas. 54)", NOMCOLXX: "MDDAYYYY_DAV.MDDATIPT" },
  { CAMPODES: "Fecha Tipo Cambio 3 (Cas. 55)", NOMCOLXX: "MDDAYYYY_DAV.MDDATIFT" },
  { CAMPODES: "Existe Intermediacion (Cas. 56)", NOMCOLXX: "MDDAYYYY_DAV.MDDAEXIN" },
  { CAMPODES: "Tipo Intermediario (Cas. 57)", NOMCOLXX: "MDDAYYYY_DAV.MDDACOIN" },
  { CAMPODES: "Intermediario Especifique (Cas. 58)", NOMCOLXX: "MDDAYYYY_DAV.MDDACINT" },
  { CAMPODES: "Primer Apellido Intermediario (Cas. 59)", NOMCOLXX: "MDDAYYYY_DAV.PRCLPAXX" },
  { CAMPODES: "Segundo Apellido Intermediario (Cas. 60)", NOMCOLXX: "MDDAYYYY_DAV.PRCLSAXX" },
  { CAMPODES: "Primer Nombre Intermediario (Cas. 61)", NOMCOLXX: "MDDAYYYY_DAV.PRCLPNXX" },
  { CAMPODES: "Otros Nombres Intermediario (Cas. 62)", NOMCOLXX: "MDDAYYYY_DAV.PRCLONXX" },
  { CAMPODES: "Razon Social Intermediario (Cas. 63)", NOMCOLXX: "MDDAYYYY_DAV.PRCLRAIN" },
  { CAMPODES: "Direccion Intermediario (Cas. 64)", NOMCOLXX: "MDDAYYYY_DAV.PRCLDIRX" },
  { CAMPODES: "Ciudad Intermediario (Cas. 65)", NOMCOLXX: "MDDAYYYY_DAV.CIUIDXXX" },
  { CAMPODES: "Cod Estado Mercancia (Cas. 73)", NOMCOLXX: "MDDAYYYY_DAV.ESTMERID" },
  { CAMPODES: "Año Fabricacion (Cas. 74)", NOMCOLXX: "MDDAYYYY_DAV.MDDAANFA" },
  { CAMPODES: "Otras Caracteristicas (Cas. 75)", NOMCOLXX: "MDDAYYYY_DAV.MDDAOTCA" },
  { CAMPODES: "Cantidad (Cas. 76)", NOMCOLXX: "MDDAYYYY_DAV.MDDACANT" },
  { CAMPODES: "Unidad Comercial (Cas. 77)", NOMCOLXX: "MDDAYYYY_DAV.UNIIDXXX" },
  { CAMPODES: "Existe Restricciones (Cas. 79)", NOMCOLXX: "MDDAYYYY_DAV.MDDAEXRE" },
  { CAMPODES: "Tipo Restriccion (Cas. 80)", NOMCOLXX: "MDDAYYYY_DAV.CODRESTX" },
  { CAMPODES: "Condiciones o Contraprestaciones (Cas. 81)", NOMCOLXX: "MDDAYYYY_DAV.MDDAECCM" },
  { CAMPODES: "Tipo Condicion (Cas. 82)", NOMCOLXX: "MDDAYYYY_DAV.CODCONDX" },
  { CAMPODES: "Condicion Especifique (Cas. 83)", NOMCOLXX: "MDDAYYYY_DAV.MDDAESCT" },
  { CAMPODES: "Puede Determinarse el Valor (Cas. 84)", NOMCOLXX: "MDDAYYYY_DAV.MDDAPUDE" },
  { CAMPODES: "Existen Canones y Derechos (Cas. 85)", NOMCOLXX: "MDDAYYYY_DAV.MDDAECDL" },
  { CAMPODES: "Existen Reversiones al Vendedor (Cas. 86)", NOMCOLXX: "MDDAYYYY_DAV.MDDAERVX" },
  { CAMPODES: "Existe Vinculacion (Cas. 87)", NOMCOLXX: "MDDAYYYY_DAV.MDDAEVCP" },
  { CAMPODES: "Tipo Vinculacion (Cas. 88)", NOMCOLXX: "MDDAYYYY_DAV.CODVINID" },
  { CAMPODES: "Influye Vinculacion en Precio (Cas. 89)", NOMCOLXX: "MDDAYYYY_DAV.MDDABNIP" },
  { CAMPODES: "Existen Valores Criterio (Cas. 90)", NOMCOLXX: "MDDAYYYY_DAV.MDDAEXVC" },
  { CAMPODES: "Declaracion de Importacion (Cas. 91)", NOMCOLXX: "MDDAYYYY_DAV.MDDALIMA" },
  { CAMPODES: "Fecha Declaracion Importacion (Cas. 92)", NOMCOLXX: "MDDAYYYY_DAV.MDDALIMF" },
  { CAMPODES: "Precio Neto Factura Moneda (Cas. 93)", NOMCOLXX: "MDDAYYYY_DAV.MDDAPNSF" },
  { CAMPODES: "Precio Neto Factura USD (Cas. 94)", NOMCOLXX: "MDDAYYYY_DAV.MDDAPNFD" },
  { CAMPODES: "Pagos Indirectos Moneda (Cas. 95)", NOMCOLXX: "MDDAYYYY_DAV.MDDARAOT" },
  { CAMPODES: "Pagos Indirectos USD (Cas. 96)", NOMCOLXX: "MDDAYYYY_DAV.MDDARAOD" },
  { CAMPODES: "Precio Pagado USD (Cas. 97)", NOMCOLXX: "MDDAYYYY_DAV.MDDAPPOP" },
  { CAMPODES: "Comisiones Moneda (Cas. 98)", NOMCOLXX: "MDDAYYYY_DAV.MDDACOCO" },
  { CAMPODES: "Comisiones USD (Cas. 99)", NOMCOLXX: "MDDAYYYY_DAV.MDDACOCD" },
  { CAMPODES: "Envases y Embalajes Moneda (Cas. 100)", NOMCOLXX: "MDDAYYYY_DAV.MDDAENEM" },
  { CAMPODES: "Envases y Embalajes USD (Cas. 101)", NOMCOLXX: "MDDAYYYY_DAV.MDDAENED" },
  { CAMPODES: "Prestaciones Materias Primas Moneda (Cas. 102)", NOMCOLXX: "MDDAYYYY_DAV.MDDAPMPO" },
  { CAMPODES: "Prestaciones Materias Primas USD (Cas. 103)", NOMCOLXX: "MDDAYYYY_DAV.MDDAPMPD" },
  { CAMPODES: "Prestaciones Herramientas Moneda (Cas. 104)", NOMCOLXX: "MDDAYYYY_DAV.MDDAPHME" },
  { CAMPODES: "Prestaciones Herramientas USD (Cas. 105)", NOMCOLXX: "MDDAYYYY_DAV.MDDAPHMD" },
  { CAMPODES: "Prestaciones Insumos Moneda (Cas. 106)", NOMCOLXX: "MDDAYYYY_DAV.MDDAPIOM" },
  { CAMPODES: "Prestaciones Insumos USD (Cas. 107)", NOMCOLXX: "MDDAYYYY_DAV.MDDAPIOD" },
  { CAMPODES: "Prestaciones Ingenieria Moneda (Cas. 108)", NOMCOLXX: "MDDAYYYY_DAV.MDDAPICP" },
  { CAMPODES: "Prestaciones Ingenieria USD (Cas. 109)", NOMCOLXX: "MDDAYYYY_DAV.MDDAPICD" },
  { CAMPODES: "Canones y Derechos Moneda (Cas. 110)", NOMCOLXX: "MDDAYYYY_DAV.MDDACDLR" },
  { CAMPODES: "Canones y Derechos USD (Cas. 111)", NOMCOLXX: "MDDAYYYY_DAV.MDDACLDL" },
  { CAMPODES: "Producto Reventa Moneda (Cas. 112)", NOMCOLXX: "MDDAYYYY_DAV.MDDAPRCU" },
  { CAMPODES: "Producto Reventa USD (Cas. 113)", NOMCOLXX: "MDDAYYYY_DAV.MDDAPRCD" },
  { CAMPODES: "Lugar de Importacion (Cas. 114)", NOMCOLXX: "MDDAYYYY_DAV.MDDAODIX" },
  { CAMPODES: "Gastos Transporte Exterior Moneda (Cas. 115)", NOMCOLXX: "MDDAYYYY_DAV.MDDAGTME" },
  { CAMPODES: "Gastos Transporte Exterior USD (Cas. 116)", NOMCOLXX: "MDDAYYYY_DAV.MDDAGTMD" },
  { CAMPODES: "Gastos Transporte Embarque Moneda (Cas. 117)", NOMCOLXX: "MDDAYYYY_DAV.MDDAGTLE" },
  { CAMPODES: "Gastos Transporte Embarque USD (Cas. 118)", NOMCOLXX: "MDDAYYYY_DAV.MDDAGTLD" },
  { CAMPODES: "Gastos Carga Descarga Moneda (Cas. 119)", NOMCOLXX: "MDDAYYYY_DAV.MDDAGCDM" },
  { CAMPODES: "Gastos Carga Descarga USD (Cas. 120)", NOMCOLXX: "MDDAYYYY_DAV.MDDAGCDD" },
  { CAMPODES: "Seguro Moneda (Cas. 121)", NOMCOLXX: "MDDAYYYY_DAV.MDDASEGX" },
  { CAMPODES: "Seguro USD (Cas. 122)", NOMCOLXX: "MDDAYYYY_DAV.MDDASEGD" },
  { CAMPODES: "Total Adiciones USD (Cas. 123)", NOMCOLXX: "MDDAYYYY_DAV.MDDATOAD" },
  { CAMPODES: "Gastos Entrega Posteriores Moneda (Cas. 124)", NOMCOLXX: "MDDAYYYY_DAV.MDDAGEPI" },
  { CAMPODES: "Gastos Entrega Posteriores USD (Cas. 125)", NOMCOLXX: "MDDAYYYY_DAV.MDDAGEPD" },
  { CAMPODES: "Gastos Construccion Moneda (Cas. 126)", NOMCOLXX: "MDDAYYYY_DAV.MDDAGCAI" },
  { CAMPODES: "Gastos Construccion USD (Cas. 127)", NOMCOLXX: "MDDAYYYY_DAV.MDDAGCAD" },
  { CAMPODES: "Derechos Aduana Moneda (Cas. 128)", NOMCOLXX: "MDDAYYYY_DAV.MDDADAOI" },
  { CAMPODES: "Derechos Aduana USD (Cas. 129)", NOMCOLXX: "MDDAYYYY_DAV.MDDADAOD" },
  { CAMPODES: "Intereses Moneda (Cas. 130)", NOMCOLXX: "MDDAYYYY_DAV.MDDAINTE" },
  { CAMPODES: "Intereses USD (Cas. 131)", NOMCOLXX: "MDDAYYYY_DAV.MDDAINTD" },
  { CAMPODES: "Otros Gastos Moneda (Cas. 132)", NOMCOLXX: "MDDAYYYY_DAV.MDDAOTGA" },
  { CAMPODES: "Otros Gastos USD (Cas. 133)", NOMCOLXX: "MDDAYYYY_DAV.MDDAOTGD" },
  { CAMPODES: "Total Deducciones USD (Cas. 134)", NOMCOLXX: "MDDAYYYY_DAV.MDDATODD" },
  { CAMPODES: "Valor Transaccion Declarado USD (Cas. 135)", NOMCOLXX: "MDDAYYYY_DAV.MDDAVTDD" },
  { CAMPODES: "Caracter Valor Provisional (Cas. 136)", NOMCOLXX: "MDDAYYYY_DAV.MDDACVPR" },
  { CAMPODES: "NIT Signatario (Cas. 137)", NOMCOLXX: "MDDAYYYY_DAV.MDDANITD" },
  { CAMPODES: "DV Signatario (Cas. 138)", NOMCOLXX: "MDDAYYYY_DAV.MDDADVDX" },
  { CAMPODES: "Primer Apellido Signatario (Cas. 139)", NOMCOLXX: "MDDAYYYY_DAV.MDDAPADX" },
  { CAMPODES: "Segundo Apellido Signatario (Cas. 140)", NOMCOLXX: "MDDAYYYY_DAV.MDDASADX" },
  { CAMPODES: "Primer Nombre Signatario (Cas. 141)", NOMCOLXX: "MDDAYYYY_DAV.MDDAPNDX" },
  { CAMPODES: "Otros Nombres Signatario (Cas. 142)", NOMCOLXX: "MDDAYYYY_DAV.MDDAONDX" },
  { CAMPODES: "Fecha Expedicion (Cas. 143)", NOMCOLXX: "MDDAYYYY_DAV.MDDAFEEX" },
];

// Configuración de colores para estados para la Creacion del DO
export const settingsColorCreateDoStatus = [
  {
    title: "SAFAESTX",
    params: [
      { value: "PENDIENTE", color: "neutral-400" },
      { value: "CON SALDO", color: "success-400" },
      { value: "SIN SALDO", color: "error-400" },
    ],
  },
];

// Configuración de columnas para Creacion del DO
export const columnsSoporteValor = [
  {
    CAMPODES: "Nro Doc. Soporte de Valor",
    NOMCOLXX: "FACIDXXX",
    SHOWCOLX: "SI",
    CAMPKEYX: "SI",
    CENTERXX: true,
    SELECTXX: "SI",
  },
  {
    CAMPODES: "Fecha Doc. Soporte de Valor",
    NOMCOLXX: "FACFECXX",
    SHOWCOLX: "SI",
    CAMPKEYX: "SI",
    CENTERXX: true,
  },
  {
    CAMPODES: "Cliente",
    NOMCOLXX: "CLINOMXX",
    SHOWCOLX: "SI",
    CAMPKEYX: "NO",
    CENTERXX: true,
  },
  {
    CAMPODES: "Proveedor",
    NOMCOLXX: "PRORAZXX",
    SHOWCOLX: "SI",
    CAMPKEYX: "NO",
    CENTERXX: true,
  },
  {
    CAMPODES: "Término de Negociación",
    NOMCOLXX: "TERMIDXX",
    SHOWCOLX: "SI",
    CAMPKEYX: "SI",
    CENTERXX: true,
  },
  {
    CAMPODES: "Moneda",
    NOMCOLXX: "MONIDXXX",
    SHOWCOLX: "SI",
    CAMPKEYX: "SI",
    CENTERXX: true,
  },
  {
    CAMPODES: "Estado",
    NOMCOLXX: "SAFAESTX",
    SHOWCOLX: "SI",
    CAMPKEYX: "SI",
    SELECTXX: "SI",
    CENTERXX: true,
  },
];

// Configuración de columnas para Documento de Transporte
export const columnsTransporte = [
  {
    CAMPODES: "Nro. Doc de Transporte",
    NOMCOLXX: "DTRCDOTR",
    SHOWCOLX: "SI",
    CAMPKEYX: "SI",
    CENTERXX: true,
  },
  {
    CAMPODES: "Fecha Estimada de Arribo",
    NOMCOLXX: "DTTIFEES",
    SHOWCOLX: "SI",
    CAMPKEYX: "SI",
    CENTERXX: true,
  },
  {
    CAMPODES: "Jurisdicción Aduanera",
    NOMCOLXX: "ODIIDDES",
    SHOWCOLX: "SI",
    CAMPKEYX: "SI",
    CENTERXX: true,
  },
  {
    CAMPODES: "Medio de Transporte",
    NOMCOLXX: "MTRDESXX",
    SHOWCOLX: "SI",
    CAMPKEYX: "SI",
    CENTERXX: true,
  },
  {
    CAMPODES: "Transportadora",
    NOMCOLXX: "TRANDESX",
    SHOWCOLX: "SI",
    CAMPKEYX: "SI",
    CENTERXX: true,
  },
  {
    CAMPODES: "Peso",
    NOMCOLXX: "DRTCPEBR",
    SHOWCOLX: "SI",
    CAMPKEYX: "SI",
    CENTERXX: true,
  },
  {
    CAMPODES: "Bultos",
    NOMCOLXX: "DRTCBUTO",
    SHOWCOLX: "SI",
    CAMPKEYX: "SI",
    CENTERXX: true,
  },
  {
    CAMPODES: "Depósito",
    NOMCOLXX: "DEPDESXX",
    SHOWCOLX: "SI",
    CAMPKEYX: "SI",
    CENTERXX: true,
  },
  {
    CAMPODES: "Estado",
    NOMCOLXX: "DOCTRAES",
    SHOWCOLX: "SI",
    CAMPKEYX: "SI",
    SELECTXX: "NO",
    CENTERXX: true,
  },
]

export const settingsColorStatusTransporte = [
  {
    title: "DOCTRAES",
    params: [
      { value: "CON SALDO", color: "success-400" },
      { value: "PENDIENTE", color: "neutral-400" },
      { value: "SIN SALDO", color: "error-400" },
    ],
  },
]
